module.exports = __webpack_public_path__ + "static/media/S1-35-Phroniac-cod66.01a65fc4.png";